__turbopack_context__.v({
  "wrapper": "ArticlePopup-module-scss-module__HHICPq__wrapper",
});
